import MainHeroBanner from "../../assets/images/cms/sky-shape.png";
import { useTranslation } from "react-i18next";

interface CmsBannerProps {
  title: string;
  description?: string;
  classNameShape?: string;
  height?: string;
}

const CmsBanner = ({ title, description, classNameShape, height }: CmsBannerProps) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <>
      <section className={`w-full md:bg-[size:100%_100%] bg-cover bg-top bg-no-repeat flex justify-center items-center relative z-10 
h-[100px]  md:h-[140px] 2xl:h-[10vw] bg-primary-skyblue`}
      // ${height ? height : "2xl:h-[30vw] lg:h-[400px] h-[300px]"}
      // style={{ backgroundImage: `url(${MainHeroBanner})` }} 
      >

      </section>
    </>
  );
};
// h-[150px]  md:h-[170px] 2xl:h-[15vw]

export default CmsBanner;
